import Pagination from './Pagination';
export * from './Pagination';
export default Pagination;
